export const siteSettings = {
  name: "Clearsky Exchange",
  link: "https://clearskyexchange.org",
  email: "support@clearskyexchange.org",
  appLink: "https://app.clearskyexchange.org",
};
